import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var UIGroup;
(function (UIGroup) {
    UIGroup.get = createAccessors(arrayGetSet('ui_groups'), {
        name: 'Вкладка 1',
        is_hidden: false,
        hide_titles: false,
        icon: 0,
        items: [],
        position: 0,
    });
})(UIGroup || (UIGroup = {}));
